import ModuleCenter from "../../datamodule/ModuleCenter";
import { enter, replace } from '../../router/RouterPath';

class DefaultActions {
    static doEnter(viewState, module, field, value, data) {
        if (field) {
            enter(module + '.' + field, value, viewState);
        } else {
            const m = ModuleCenter.getModule(module);
            enter(module + '.' + m.defaultKeyField(), value, viewState, data);
        }
    }
    static doReplace(viewState, module, field, value, data) {
        if (field) {
            replace(module + '.' + field, value, viewState);
        } else {
            const m = ModuleCenter.getModule(module);
            replace(module + '.' + m.defaultKeyField(), value, viewState, data);
        }
    }
}

export default DefaultActions;